export const SESSION_MERGE_STATUS = {
  YET_TO_START: 'yet_to_start',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAILED: 'failed'
} as const;

export const SESSION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const;

export const SESSION_MODE = {
  IDEATE: 'ideate',
  BUILD: 'build'
} as const;

export const SESSION_DRIVEN_MODE = {
  AUTO: 'auto',
  MANUAL: 'manual'
} as const;

export const CONVERSATION_STATUS = {
  COMPLETED: 'completed'
} as const;
